<div *ngIf="!profileLoading">
<div [formGroup]="parentForm" class="row">

  <div class="col-sm-12 col-lg-8">
    <div class="form-group">
      <label for="clinicMedCenter">Clinic/Med Center</label>
      <input id="clinicMedCenter" formControlName="clinicMedCenter"
             [readonly]="!canEditProfileAttribute"
             [(ngModel)]="user.clinicMedCenter"
             [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
             maxlength="200"/>
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group input-required">
      <label for="fax">Fax</label>
      <input id="fax" formControlName="fax" [(ngModel)]="user.fax" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" maxlength="10"/>
      <small *ngIf="parentForm.get('fax')?.hasError('required') && parentForm.get('fax')?.dirty" class="text-danger">
        This field is required.
      </small>
      <small *ngIf="parentForm.get('fax')?.hasError('pattern') && parentForm.get('fax')?.dirty" class="text-danger">
        Fax must be 10 digits, cannot start with "1", and should contain only numbers.
      </small>
    </div>
  </div>

  <div class="col-sm-12 col-lg-8">
    <div class="form-group input-required">
      <label for="addressLine1">Address Line 1</label>
      <input id="addressLine1" formControlName="addressLine1" [(ngModel)]="user.addressLine1" [readonly]="!canEditProfileAttribute"
             [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
             maxlength="50"/>
      <small *ngIf="parentForm.get('addressLine1')?.invalid && parentForm.get('addressLine1')?.dirty" class="text-danger">
        This field is required.
      </small>
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="pager">Pager</label>
      <input id="pager" formControlName="pager" [(ngModel)]="user.pager" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" maxlength="10"/>
      <small *ngIf="parentForm.get('pager')?.hasError('pattern') && parentForm.get('pager')?.dirty" class="text-danger">
        Pager must be 10 digits, cannot start with "1", and should contain only numbers.
      </small>
    </div>
  </div>


  <div class="col-sm-12 col-lg-8">
    <div class="form-group">
      <label for="addressLine2">Address Line 2</label>
      <input id="addressLine2" formControlName="addressLine2" [(ngModel)]="user.addressLine2" [readonly]="!canEditProfileAttribute"
             [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
             maxlength="50"/>
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="directEmail">Direct Email</label>
      <input id="directEmail" formControlName="directEmail" [(ngModel)]="user.directEmail" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" />
      <small *ngIf="parentForm.get('directEmail')?.hasError('email') && parentForm.get('directEmail')?.dirty" class="text-danger">
        Please enter a valid email address.
      </small>
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group input-required">
      <label for="city">City</label>
      <input id="city" formControlName="city" [readonly]="!canEditProfileAttribute" [(ngModel)]="user.city"
             [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
             maxlength="50"/>
      <small *ngIf="parentForm.get('city')?.invalid && parentForm.get('city')?.dirty" class="text-danger">
        This field is required.
      </small>
    </div>
  </div>

  <div class="col-sm-6 col-lg-1">
    <div class="form-group input-required">
      <label for="state">State</label>
      <select id="state" formControlName="state"
              [disabled]="!canEditProfileAttribute" [(ngModel)]="user.state"
              [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
              style="flex: 1;"
              [attr.disabled]="!canEditProfileAttribute ? true : null">
        <option *ngFor="let state of stateCodes" [value]="state">{{ state }}</option>
      </select>
      <small *ngIf="parentForm.get('state')?.invalid && parentForm.get('state')?.dirty" class="text-danger">
        This field is required.
      </small>
    </div>
  </div>

  <div class="col-sm-6 col-lg-3">
    <div class="form-group input-required">
      <label for="zip">ZIP</label>
      <input id="zip" formControlName="zip" [(ngModel)]="user.zip" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" maxlength="5"/>
      <small *ngIf="parentForm.get('zip')?.hasError('required') && parentForm.get('zip')?.dirty" class="text-danger">
        This field is required.
      </small>
      <small *ngIf="parentForm.get('zip')?.hasError('pattern') && parentForm.get('zip')?.dirty" class="text-danger">
        ZIP must be exactly 5 digits and contain only numbers.
      </small>
    </div>
  </div>

  <br>
  <!--  divider-->
  <div style="width: 100%; height: 1px; background-color: lightgray;"></div>
  <br>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="upin">UPIN</label>
      <input id="upin" formControlName="upin" [(ngModel)]="user.upin" [readonly]="!canEditProfileAttribute"
             [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
              maxlength="50"/>
      <small *ngIf="parentForm.get('upin')?.hasError('pattern') && parentForm.get('upin')?.dirty" class="text-danger">
        Only alphanumeric characters are allowed.
      </small>
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="taxonomyCode">Taxonomy Code</label>
      <input id="taxonomyCode" formControlName="taxonomyCode" [(ngModel)]="user.taxonomyCode" [readonly]="!canEditProfileAttribute"
             [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
             maxlength="10"/>
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="licenseNumber">License Number</label>
      <input id="licenseNumber" formControlName="licenseNumber" [(ngModel)]="user.licenseNumber" maxlength="25" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" />
    </div>
  </div>


  <div class="col-sm-6 col-lg-4">
    <div class="form-group input-required">
      <label for="npi">National Provider ID (NPI)</label>
      <input id="npi" formControlName="npi" [(ngModel)]="user.npi" [readonly]="!canEditProfileAttribute"
             [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
             maxlength="10"/>
      <small *ngIf="parentForm.get('npi')?.invalid && parentForm.get('npi')?.dirty" class="text-danger">
        This field is mandatory and is required to be 10 digits.
      </small>
      <small *ngIf="parentForm.get('npi')?.errors?.['invalidNpi'] && parentForm.get('npi')?.dirty" class="text-danger">
        Please enter a valid NPI number.
      </small>
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="taxIdNumber">Tax ID Number</label>
      <input id="taxIdNumber" formControlName="taxIdNumber" [(ngModel)]="user.taxIdNumber" maxlength="25" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" />
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="medicaidNumber">Medicaid Number</label>
      <input id="medicaidNumber" formControlName="medicaidNumber" [(ngModel)]="user.medicaidNumber" maxlength="25" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" />
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="medicareNumber">Medicare Number</label>
      <input id="medicareNumber" formControlName="medicareNumber" [(ngModel)]="user.medicareNumber" maxlength="25" [readonly]="!canEditProfileAttribute" [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}" />
    </div>
  </div>

  <div class="col-sm-6 col-lg-4">
    <div class="form-group">
      <label for="nadeanNumber">NADEAN Number</label>
      <input id="nadeanNumber" formControlName="nadeanNumber" [(ngModel)]="user.nadeanNumber" [readonly]="!canEditProfileAttribute"
             [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
              maxlength="9"/>
    </div>
  </div>


</div>
  <div [formGroup]="parentForm" class="row">
    <div formArrayName="stateDeaNumbers" class="col-sm-6 col-lg-4">
      <div *ngFor="let stateDea of stateDeaNumbers.controls; let i = index" [formGroupName]="i" class="row mb-3">
        <div class="col-sm-6 col-lg-3">
          <div class="form-group">
            <label for="stateForDeaNumber-{{i}}">State</label>
            <select id="stateForDeaNumber-{{i}}" formControlName="stateForDeaNumber"
                    [disabled]="!canEditProfileAttribute"
                    [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
                    [attr.disabled]="!canEditProfileAttribute ? true : null">
              <option *ngFor="let state of stateCodes" [value]="state">{{ state }}</option>
            </select>
            <small *ngIf="stateDea.hasError('conditionalRequired')" class="text-danger">
              Both State and DEA Number are required if one is filled.
            </small>
          </div>
        </div>
        <div class="col-sm-6 col-lg-4">
          <div class="form-group">
            <label for="deaNumber-{{i}}">DEA Number</label>
            <div class="d-flex">
              <input id="deaNumber-{{i}}" formControlName="deaNumber"
                     [readonly]="!canEditProfileAttribute" maxlength="9"
                     [ngClass]="{'form-control': canEditProfileAttribute, 'form-control-plaintext': !canEditProfileAttribute}"
                     style="width: 300px;" class="me-2"
                     (blur)="onDeaNumberBlur(i)"
                     (input)="onDeaNumberInput(i)"
                     (keyup)="onDeaNumberInput(i)" />
              <button type="button" class="btn btn-sm" (click)="removeStateDeaNumber(i)" style="background-color: white; border: 1px solid red;"
                      [disabled]="!canEditProfileAttribute">
                <i class="fa-regular fa-trash-can" style="color: red;"></i>
              </button>
            </div>
            <small *ngIf="stateDea.get('deaNumber')?.hasError('invalidDea')" class="text-danger">
              {{ stateDea.get('deaNumber')?.errors?.['invalidDea'] }}
            </small>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-primary" [attr.disabled]="!canEditProfileAttribute ? true : null"
              (click)="addStateDeaNumber()"
              style="background-color: white; border: 1px solid blue; color: blue;">
        + Add DEA Number
      </button>
    </div>
  </div>

</div>
